import { createAction } from 'actions/utils'

export const SET_SELECTED_ID = 'SET_SELECTED_ID'
export const setSelectedId = createAction(SET_SELECTED_ID, ['id'])
export const setSelectedIdWithDrawer = createAction(SET_SELECTED_ID, ['id'], {
  withDrawer: true,
})

export const SET_COMPONENT_META = 'SET_COMPONENT_META'
export const setComponentMeta = createAction(SET_COMPONENT_META, [
  'id',
  'componentMeta',
])

export const setSelectedIdWithMeta = createAction(SET_SELECTED_ID, [
  'id',
  'componentMeta',
])

export const setSelectedIdWithDrawerAndMeta = createAction(
  SET_SELECTED_ID,
  ['id', 'componentMeta'],
  {
    withDrawer: true,
  }
)

export const REMOVE_COMPONENT_META = 'REMOVE_COMPONENT_META'
export const removeComponentMeta = createAction(REMOVE_COMPONENT_META, ['ids'])

export const SET_IS_EDITING = 'SET_IS_EDITING'
export const setIsEditing = createAction(SET_IS_EDITING, [
  'isEditing',
  'entity',
])

export const NAVIGATOR_IS_FULLSCREEN = 'NAVIGATOR_IS_FULLSCREEN'
export const navigatorIsFullscreen = createAction(NAVIGATOR_IS_FULLSCREEN, [
  'isFullscreen',
])

export const NAVIGATOR_RESET = 'NAVIGATOR_RESET'
export const navigatorReset = createAction(NAVIGATOR_RESET)

export const SET_HIDE_BREADCRUMB = 'SET_HIDE_BREADCRUMB'
export const setHideBreadcrumb = createAction(SET_HIDE_BREADCRUMB, [
  'hideBreadcrumb',
])
